import {
  IsArray,
  IsNotEmpty,
  IsUUID,
  IsOptional,
  IsInt,
} from 'class-validator';

import { EventListRequestFilters } from '@app/gen/events';

export class BatchDownloadStartDto {
  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsNotEmpty()
  event_ids: string[];

  @IsInt()
  @IsOptional()
  totalCount?: number;

  filters?: EventListRequestFilters;
}
